'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentaryCreditData(number, issueDate, issuingBank) {
  this.uM = null;
  this.uK = null;
  this.uL = null;
  this.uM = number;
  this.uK = issueDate;
  this.uL = issuingBank;
}
export { $c_Lapp_data_DocumentaryCreditData as $c_Lapp_data_DocumentaryCreditData };
$p = $c_Lapp_data_DocumentaryCreditData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentaryCreditData;
/** @constructor */
function $h_Lapp_data_DocumentaryCreditData() {
}
export { $h_Lapp_data_DocumentaryCreditData as $h_Lapp_data_DocumentaryCreditData };
$h_Lapp_data_DocumentaryCreditData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DocumentaryCreditData)) {
    if ((this.uM === x$0.uM)) {
      var x = this.uK;
      var x$2 = x$0.uK;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.uL;
      var x$4 = x$0.uL;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "DocumentaryCreditData";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.uM;
      break;
    }
    case 1: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.uK);
      break;
    }
    case 2: {
      return this.uL;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "issueDate";
      break;
    }
    case 2: {
      return "issuingBank";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_DocumentaryCreditData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jq)));
}
export { $isArrayOf_Lapp_data_DocumentaryCreditData as $isArrayOf_Lapp_data_DocumentaryCreditData };
var $d_Lapp_data_DocumentaryCreditData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentaryCreditData, "app.data.DocumentaryCreditData", ({
  jq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_DocumentaryCreditData as $d_Lapp_data_DocumentaryCreditData };
//# sourceMappingURL=app.data.-Documentary-Credit-Data.js.map
